export function LeadText({ children }) {
	return <div className="text-lg mb-8">{ children }</div>
}